import {
	OFFERS_RECEIVED,
	IS_RELOAD_OFFERS,
	EDIT_OFFER,
	IS_NEW_USER,
	RECEIVE_OFFERS_LOCALE,
	SEARCHING_OFFERS,
	SHOW_OFFERS,
	RECEIVE_OFFER_RANK,
	SENDING_OFFER,
	VIEW_RANKING,
	QUICK_SALE_CLEAN
} from "../shared/constants";

const initialOffersState = {};

export const offers = (state = initialOffersState, action) => {
	switch (action.type) {
		case OFFERS_RECEIVED:
			return {
				...state,
				data: action.data,
				loading: false,
				error: action.error
			};
		case IS_RELOAD_OFFERS:
			return {
				...state,
				reload: action.reload
			};
		case EDIT_OFFER:
			return {
				...state,
				offer: action.offer,
				viewMode: "edit"
			};
		case SHOW_OFFERS:
			return {
				...state,
				viewMode: state.viewMode == "new" ? "new" : undefined
			};
		case IS_NEW_USER:
			return {
				...state,
				newUser: action.newUser,
				viewMode: action.newUser ? "new" : undefined
			};
		case RECEIVE_OFFERS_LOCALE:
			return {
				...state,
				[action.locale]: { data: action.offers, loading: false, error: action.error }
			};
		case SEARCHING_OFFERS:
			return {
				...state,
				data: undefined,
				loading: true,
				error: undefined,
				ranks: {}
			};
		case RECEIVE_OFFER_RANK:
			return {
				...state,
				ranks: Object.assign({}, state.ranks, { [action.offerId]: action.rank })
			};
		case SENDING_OFFER:
			return {
				...state,
				sending: action.sending,
				successSend: action.success,
				showSendModal: action.show,
				newUser: undefined
			};
		case QUICK_SALE_CLEAN:
			return {
				...state,
				successSend: undefined,
				showSendModal: {
					offer: undefined,
					message: undefined
				}
			};
		case VIEW_RANKING:
			return {
				...state,
				rankingId: action.id
			};

		default:
			return state;
	}
};
